import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useRefund(data = {}) {
  const { enabled = false, refundId } = data;
  const { privateFetch } = useContext(FetchContext);

  const getRefund = () => privateFetch.get(`/v1/admin/refunds/${refundId}`);

  return useQuery(['refund-detail', refundId], getRefund, {
    enabled: enabled && !!refundId,
    keepPreviousData: false,
  });
}

export default useRefund;
